import React, { useCallback } from 'react'
import { Link, useParams } from 'react-router-dom'

const getRowButton = ({ state, setState }) => {
  const params = useParams()

  const meetingPrecheck = useCallback(() => {
    window.api.get(`/virtual_portal/meeting_precheck/timeslot_id/${state.oneOnOneTimeslot.id}/meeting_id/${state.oneOnOneTimeslot.event_one_on_one_meeting.id}`).then((response) => {
      setState({ emergencyBroadcastMessage: response.data.emergency_broadcast_message })
      if(response.data.meta === 'join_existing_meeting'){
        location.href = `${window.token}/meet/${state.oneOnOneTimeslot.event_one_on_one_meeting.id}`
      } else if(response.data.meta === 'join_newly_scheduled_meeting') {
        setState({
          meetingPrecheckModalIsOpen: true,
          meetingPrecheckResult: response.data.meta === 'join_newly_scheduled_meeting',
          meetingPreCheckBtn: (
            <button className='btn close-modal btn-danger'>
              <Link to={ `${params.token}/meet/${response.data.new_meeting.id}` }>CONTINUE</Link>
            </button>
          ),
          meetingPrecheckModalContent: (
            <div>This meeting has been rescheduled. You are now scheduled to meet with: <br/>
              <div className='centered'>
                {response.data.new_meeting.full_name}<br/>
                {response.data.new_meeting.title}<br/>
                {response.data.new_meeting.organization_name}
              </div>
            </div>
          )
        })
      } else {
        setState({
          meetingPrecheckModalIsOpen: true,
          meetingPrecheckResult: response.data.meta === 'needs_refresh',
          meetingPreCheckBtn: (
            <button
              className='btn btn-danger close-modal'
              onClick={() => window.location.href = `${params.token}`}>
              CONTINUE
            </button>
          ),
          meetingPrecheckModalContent: 'This meeting no longer exists. Please try refreshing the page. If the problem persists, an admin will reach out to assist you.'
        })
      }
    })
  },[params, state])

  const evalButton = useCallback(() => {
    if (state.evaluationCompleted){
      return <button className='eblue-button timeslot-btn feedback-given' disabled><i className='fa fa-check-circle'></i> Feedback</button>
    } else {
      return <button className='eblue-button timeslot-btn give-feedback' onClick={ () => setState({ isOpen: true }) }>Give Feedback</button>
    }
  },[state])

  const toggleOptout = useCallback((action) => {
    setState({oneOnOneTimeslotOptOut: true})
    if(action == 'blocking'){
      const data = {
        event_session_one_on_one_timeslot_survey_user_opt_out: {
          event_session_one_on_one_timeslot_id: state.oneOnOneTimeslot.id
        }
      }
      window.api.post('/virtual_portal/event_session_one_on_one_timeslot_survey_user_opt_outs', data).then((response) => {
        let oneOnOneTimeslot = {...state.oneOnOneTimeslot}
        oneOnOneTimeslot.opt_out_id = response.data.event_session_one_on_one_timeslot_survey_user_opt_out.id
        setState({oneOnOneTimeslot})
        setState({oneOnOneTimeslotOptOut: false})

      })
    } else {
      window.api.delete('/virtual_portal/event_session_one_on_one_timeslot_survey_user_opt_outs/' + state.oneOnOneTimeslot.opt_out_id).then(() => {
        let oneOnOneTimeslot = {...state.oneOnOneTimeslot}
        oneOnOneTimeslot.opt_out_id = null
        setState({oneOnOneTimeslot})
        setState({oneOnOneTimeslotOptOut: false})
      })
    }
  },[state])

  const isMobileBlockButton = useCallback(() => {
    if (window.screen.width >= 768){
      return (
        <button
          disabled={state.oneOnOneTimeslotOptOut}
          className='btn timeslot-btn btn-cancel' onClick={ () => toggleOptout('blocking') }>BLOCK<i className='fa fa-question helper-text' data-content="This will mark you as unavailable to meet during this time slot." rel='popover' data-placement='top' data-trigger='hover'></i></button>
      )
    } else {
      return (
        <div className='helper-text-wrapper'>
          <div className='helper-text-button'>
            <button
              disabled={state.oneOnOneTimeslotOptOut}
              className='btn timeslot-btn btn-cancel' onClick={ () => toggleOptout('blocking') }>BLOCK</button>
          </div>
          <div className='helper-text-mobile'>
            <i className='fa fa-question question-larger helper-text' data-content="This will mark you as unavailable to meet during this time slot." rel='popover' data-placement='top' data-trigger='hover'></i>
          </div>
        </div>
      )
    }
  },[state, toggleOptout])

  if(state.meetingEnded) {
    if(state.joinStatus === true) {
      return (
        evalButton()
      )
    } else {
      return ''
    }
  }
  if(state.oneOnOneTimeslot.opt_out_id) {
    return (
      // add button states here if in future need any for opt out
      ''
    )
  }
  if(!state.oneOnOneTimeslot.event_one_on_one_meeting?.id){
    return (
      isMobileBlockButton()
    )
  }
  if(state.meetingHasStarted) {
    return (
      <button className='btn timeslot-btn btn-danger' onClick={ () => meetingPrecheck() }>JOIN</button>
    )
  }
  return (
    <button className='btn timeslot-btn btn-cancel' onClick={ () => setState({ confirmModalIsOpen: true }) }>CANCEL</button>
  )
}

export default getRowButton